import flutterIcon from '../assets/images/tech/flutter.svg';
import reactNativeIcon from '../assets/images/tech/react-native.svg';
import javascriptIcon from '../assets/images/tech/javascript.svg';
import dotnetIcon from '../assets/images/tech/dotnet.svg';
import html5Icon from '../assets/images/tech/html5.svg';
import wordpressIcon from '../assets/images/tech/wordpress.svg';
import shopifyIcon from '../assets/images/tech/shopify.svg';
import cIcon from '../assets/images/tech/c.svg';

export const techIcons: { [key: string]: string } = {
  flutter: flutterIcon,
  'react-native': reactNativeIcon,
  javascript: javascriptIcon,
  dotnet: dotnetIcon,
  html5: html5Icon,
  wordpress: wordpressIcon,
  shopify: shopifyIcon,
  c: cIcon,
};

export interface ServiceContent {
  id: string;
  title: string;
  shortTitle: string; // For buttons/tabs
  description: string;
  longDescription: string; // For the detail page
  technologies: string[];
  features: string[];
  benefits: string[]; // New for detail page
  process: string[]; // New for detail page
  icon?: string; // Optional icon for the service itself
}

export const servicesData: { [key: string]: ServiceContent } = {
  'mobile-app': {
    id: 'mobile-app',
    title: 'Mobile App Entwicklung\n iOS & Android',
    shortTitle: 'Mobile App',
    description: 'Wir entwickeln native Apps für iOS und Android. Ob mit Flutter oder React Native - wir finden die passende Technologie für dein Projekt. Von der Konzeption bis zum App Store Release kümmern wir uns um alles.',
    longDescription: 'In der heutigen mobilen Welt ist eine eigene App oft der Schlüssel zum Erfolg. Wir entwickeln nicht nur Apps, wir schaffen Erlebnisse. Unsere Expertise in Flutter und React Native ermöglicht es uns, kosteneffiziente Cross-Platform-Lösungen zu entwickeln, die sich wie native Apps anfühlen und verhalten. Wir begleiten dich von der ersten Idee über das UI/UX-Design bis hin zur Veröffentlichung im App Store und Google Play Store.',
    technologies: ['flutter', 'react-native'],
    features: [
      'Native iOS & Android', 
      'Cross-Platform Dev', 
      'App Store Deployment', 
      'Push Notifications',
      'In-App Purchases',
      'Offline-Modus'
    ],
    benefits: [
      'Erreiche deine Kunden direkt auf ihrem Smartphone',
      'Nutze Gerätefunktionen wie Kamera und GPS',
      'Offline-Verfügbarkeit für bessere User Experience',
      'Höhere Kundenbindung durch Push-Nachrichten'
    ],
    process: [
      'Anforderungsanalyse & Konzeption',
      'UI/UX Design & Prototyping',
      'Entwicklung & Testing',
      'Deployment & Store Submission',
      'Wartung & Updates'
    ]
  },
  'desktop-app': {
    id: 'desktop-app',
    title: 'Desktop Software\nEntwicklung - Native\nAnwendungen für Windows & macOS',
    shortTitle: 'Desktop App',
    description: 'Moderne Desktop-Anwendungen für Windows und macOS. Wir nutzen aktuelle Technologien wie Electron oder .NET, um leistungsstarke Software zu bauen, die deine Arbeitsprozesse vereinfacht.',
    longDescription: 'Für komplexe Aufgaben und rechenintensive Prozesse ist Desktop-Software oft die beste Wahl. Wir entwickeln maßgeschneiderte Anwendungen für Windows und macOS, die sich nahtlos in deine bestehende Infrastruktur integrieren. Ob Verwaltungssoftware, Analysetools oder kreative Anwendungen – wir setzen auf moderne Frameworks wie Electron und .NET für maximale Performance und Benutzerfreundlichkeit.',
    technologies: ['dotnet', 'c', 'javascript', 'flutter'],
    features: [
      'Windows & macOS', 
      'Offline-First', 
      'System Integration', 
      'High Performance',
      'Auto-Updates',
      'Hardware-Zugriff'
    ],
    benefits: [
      'Maximale Performance für anspruchsvolle Aufgaben',
      'Tiefe Integration in das Betriebssystem',
      'Unabhängigkeit von Browser-Einschränkungen',
      'Robuste Offline-Funktionalität'
    ],
    process: [
      'Workflow-Analyse',
      'Architektur-Design',
      'Native Entwicklung',
      'System-Integrationstests',
      'Rollout & Schulung'
    ]
  },
  'website': {
    id: 'website',
    title: 'Webentwicklung\nSEO-optimierte Websites\nfür mehr Erfolg',
    shortTitle: 'Website',
    description: 'Websites, die funktionieren. Schnell, sicher und gut auffindbar. Wir bauen keine Standard-Templates, sondern individuelle Lösungen, die genau zu dir und deinen Zielen passen.',
    longDescription: 'Deine Website ist dein digitales Aushängeschild. Wir gestalten und entwickeln Websites, die nicht nur gut aussehen, sondern auch performant sind und konvertieren. Mit modernsten Webtechnologien und einem Fokus auf SEO sorgen wir dafür, dass du gefunden wirst. Egal ob Landingpage, Unternehmenswebsite oder komplexes Portal – wir setzen deine Vision pixelgenau um.',
    technologies: ['html5', 'javascript', 'wordpress', 'shopify'],
    features: [
      'SEO-Optimierung', 
      'Responsive Design', 
      'CMS Integration', 
      'Performance',
      'Barrierefreiheit (A11y)',
      'DSGVO-Konformität'
    ],
    benefits: [
      'Professioneller erster Eindruck',
      'Optimiert für Suchmaschinen (SEO)',
      'Perfekte Darstellung auf allen Geräten',
      'Einfache Content-Pflege durch CMS'
    ],
    process: [
      'Zielgruppenanalyse & Strategie',
      'Webdesign & Content-Planung',
      'Frontend & Backend Entwicklung',
      'SEO-Optimierung & Launch',
      'Analytics & Optimierung'
    ]
  },
  'web-app': {
    id: 'web-app',
    title: 'Progressive Web App\nEntwicklung - Die Zukunft\nder digitalen Anwendungen',
    shortTitle: 'Web-App',
    description: 'Web-Apps, die sich wie native Anwendungen anfühlen. Mit Progressive Web Apps (PWA) erreichst du deine Nutzer überall - auch offline. Die moderne Alternative zur klassischen App.',
    longDescription: 'Progressive Web Apps (PWAs) verbinden das Beste aus Web und App. Sie sind über den Browser erreichbar, können aber auch installiert werden und offline funktionieren. Wir entwickeln PWAs, die plattformunabhängig laufen und keine Updates über App Stores benötigen. Ideal für B2B-Anwendungen, Kundenportale und SaaS-Lösungen.',
    technologies: ['javascript', 'html5', 'react-native', 'flutter'],
    features: [
      'PWA Support', 
      'Offline Functionality', 
      'App-like Experience', 
      'Cross-Browser',
      'Installierbar',
      'Push-Benachrichtigungen'
    ],
    benefits: [
      'Keine Installation notwendig',
      'Funktioniert auf jedem Gerät mit Browser',
      'Automatische Updates ohne Store-Zwang',
      'Kosteneffiziente Entwicklung'
    ],
    process: [
      'Technische Konzeption',
      'Frontend-Architektur',
      'API-Entwicklung & Integration',
      'PWA-Implementierung',
      'Performance-Tuning'
    ]
  },
  'server-software': {
    id: 'server-software',
    title: 'Backend Entwicklung\nSkalierbare Server-Lösungen',
    shortTitle: 'Server-Software',
    description: 'Das Rückgrat deiner Anwendung. Wir entwickeln skalierbare Backends und APIs, die auch bei hoher Last stabil laufen. Sicher, performant und zukunftssicher.',
    longDescription: 'Ein starkes Frontend braucht ein noch stärkeres Backend. Wir entwerfen und implementieren robuste Server-Architekturen, Datenbanken und APIs, die das Fundament deiner digitalen Produkte bilden. Sicherheit, Skalierbarkeit und Performance stehen dabei an erster Stelle. Wir nutzen moderne Technologien und Cloud-Services, um zukunftssichere Lösungen zu schaffen.',
    technologies: ['dotnet', 'c', 'javascript'],
    features: [
      'API Design', 
      'Database Architecture', 
      'Scalability', 
      'Security',
      'Microservices',
      'REST & GraphQL'
    ],
    benefits: [
      'Hohe Ausfallsicherheit und Stabilität',
      'Skalierbarkeit bei wachsenden Nutzerzahlen',
      'Sichere Datenhaltung und -übertragung',
      'Effiziente Schnittstellen für Frontends'
    ],
    process: [
      'Datenmodellierung',
      'API-Spezifikation',
      'Backend-Implementierung',
      'Sicherheits-Audits',
      'Lasttests & Deployment'
    ]
  },
  'server-admin': {
    id: 'server-admin',
    title: 'Server Administration\n& DevOps - Maximale\nVerfügbarkeit garantiert',
    shortTitle: 'Server Administration',
    description: 'Wir kümmern uns um deine Server, damit du ruhig schlafen kannst. Updates, Backups und Monitoring - wir sorgen dafür, dass deine Systeme rund um die Uhr verfügbar sind.',
    longDescription: 'Der Betrieb von Serverinfrastruktur erfordert Fachwissen und ständige Aufmerksamkeit. Wir übernehmen das Management deiner Server, richten CI/CD-Pipelines ein und sorgen für automatisierte Backups und Updates. Mit unserem Proaktiven Monitoring erkennen und beheben wir Probleme, bevor sie deine Nutzer beeinträchtigen.',
    technologies: ['c', 'dotnet', 'javascript'],
    features: [
      '24/7 Monitoring', 
      'Backups', 
      'Updates', 
      'CI/CD Pipelines',
      'Firewall-Management',
      'DDoS-Schutz'
    ],
    benefits: [
      'Minimierung von Ausfallzeiten',
      'Schutz vor Sicherheitslücken',
      'Automatisierte Deployments',
      'Transparente Performance-Reports'
    ],
    process: [
      'Infrastruktur-Analyse',
      'Setup & Härtung',
      'Monitoring-Einrichtung',
      'Backup-Strategie',
      'Laufende Wartung'
    ]
  }
};

export const serviceIds = Object.keys(servicesData);
